import { Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';
import { Tooltip } from '../components/Tooltip';
import React, { useState } from 'react';
import { MuiTelInput } from 'mui-tel-input';
import { t } from 'i18next';

const PhoneComponent: React.FC<{
  phone: string;
  setPhone: (phone: string) => void;
  disabled?: boolean;
}> = ({ phone, setPhone, disabled }) => (
  <MuiTelInput
    onlyCountries={['NZ', 'CR']}
    disableDropdown={!window.location.href.includes('?test=true')}
    label={t('phoneLabel')}
    margin="normal"
    defaultCountry="NZ"
    disabled={disabled}
    value={phone}
    inputProps={{
      maxLength: 16,
    }}
    fullWidth
    onChange={(newPhone: string) => setPhone(newPhone)}
  />
);

const EmailComponent: React.FC<{
  email: string;
  setEmail: (email: string) => void;
}> = ({ email, setEmail }) => (
  <TextField
    label={t('emailLabel')}
    value={email}
    type="email"
    margin="normal"
    fullWidth
    onChange={(e) => setEmail(e.target.value)}
  />
);

export const useReceiveCommunication = () => {
  const [receiveEmails, setReceiveEmails] = useState<boolean>(false);
  const [receiveSms, setReceiveSms] = useState<boolean>(false);
  const [phone, setPhone] = useState<string>('');
  const [email, setEmail] = useState<string>('');

  const handleReceiveEmailsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReceiveEmails(event.target.checked);
  };

  const handleReceiveSmsChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReceiveSms(event.target.checked);
  };

  const ReceiveEmailComponent = () => (
    <Stack
      direction={'row'}
      alignItems="center"
      justifyContent={'space-between'}
    >
      <FormControlLabel
        control={
          <Checkbox
            onChange={handleReceiveEmailsChange}
            checked={receiveEmails}
          />
        }
        label={t('receiveEmailNotificationsLabel')}
      />
      <Tooltip text={t('emailTooltip')} />
    </Stack>
  );

  const ReceiveSMSComponent: React.FC<{
    checkedCreditCard: boolean;
  }> = ({ checkedCreditCard }) => (
    <Stack
      direction={'row'}
      alignItems="center"
      justifyContent={'space-between'}
    >
      <FormControlLabel
        control={
          <Checkbox
            onChange={handleReceiveSmsChange}
            checked={receiveSms}
            disabled={checkedCreditCard}
          />
        }
        label={t('receiveTextNotifications')}
      />
      <Tooltip text={t('phoneTooltip')} />
    </Stack>
  );

  return {
    email,
    setEmail,
    EmailComponent,
    receiveEmails,
    setReceiveEmails,
    receiveSms,
    setReceiveSms,
    ReceiveEmailComponent,
    ReceiveSMSComponent,
    phone,
    setPhone,
    PhoneComponent,
  };
};
